// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2niot","delete":"styles_delete__3ZHxV","update":"styles_update__3ki-J","add":"styles_add__sU1Rp"};